export const SUBSCRIPTION_OVERVIEW_CARD_HEIGHT = 240
